import type {
  AiThreadScope,
  CreateThreadRequest,
  MarkAllReadRequest,
  ThreadListResponse,
  ThreadWithMessages,
  UnreadCountResponse,
} from "@repo/shared/types";
import { del, get, post } from "./_client";

const BASE = "/internal/ai/threads";

export function listThreads(params?: {
  archived?: boolean;
  clientId?: string;
  scope?: AiThreadScope;
  limit?: number;
  offset?: number;
}): Promise<ThreadListResponse> {
  const searchParams = new URLSearchParams();
  if (params?.archived) searchParams.set("archived", "true");
  if (params?.clientId) searchParams.set("clientId", params.clientId);
  if (params?.scope) searchParams.set("scope", params.scope);
  if (params?.limit) searchParams.set("limit", String(params.limit));
  if (params?.offset) searchParams.set("offset", String(params.offset));
  const qs = searchParams.toString();
  return get<ThreadListResponse>(`${BASE}${qs ? `?${qs}` : ""}`);
}

export function createThread(data: CreateThreadRequest): Promise<{ id: string }> {
  return post<{ id: string }>(BASE, data);
}

export function getThread(id: string): Promise<ThreadWithMessages> {
  return get<ThreadWithMessages>(`${BASE}/${id}`);
}

export function deleteThread(id: string): Promise<{ success: boolean }> {
  return del<{ success: boolean }>(`${BASE}/${id}`);
}

export function markThreadRead(id: string): Promise<{ success: boolean }> {
  return post<{ success: boolean }>(`${BASE}/${id}/mark-read`, {});
}

export function markAllThreadsRead(
  scope: AiThreadScope,
): Promise<{ success: boolean; updated: number }> {
  return post<{ success: boolean; updated: number }>(`${BASE}/mark-all-read`, {
    scope,
  } satisfies MarkAllReadRequest);
}

export function getUnreadCounts(): Promise<UnreadCountResponse> {
  return get<UnreadCountResponse>(`${BASE}/unread-count`);
}
